import Slide1 from "./slide-1.webp"
import Slide2 from "./slide-2.webp"
import Slide3 from "./slide-3.webp"
import Slide4 from "./slide-4.webp"
import Slide5 from "./slide-5.webp"
import Slide6 from "./slide-6.webp"
import Slide7 from "./slide-7.webp"
import Slide8 from "./slide-8.webp"
import Slide9 from "./slide-9.webp"
import Slide10 from "./slide-10.webp"
import Slide11 from "./slide-11.webp"
import Slide12 from "./slide-12.webp"
import Slide13 from "./slide-13.webp"
import Slide14 from "./slide-14.webp"
import Slide15 from "./slide-15.webp"
export {Slide1,Slide2,Slide3,Slide4,Slide5,Slide6,Slide7, Slide8,Slide9,Slide10,Slide11,Slide12,Slide13,Slide14,Slide15};